module.exports = __webpack_public_path__ + "static/Infographic5_mobile-80dc2a36c16377f4a9eff90b620fcc42.png";